import { useSignupNavigationGuard } from 'domains/signupDirect/misc/useSignupNavigationGuard';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { routes } from 'router/routes';
import { useLDFlags } from 'utils/launchdarkly/launchdarkly';

export const SignupSchedulingExperimentFork: React.FC = () => {
  useSignupNavigationGuard();

  const { signupScheduleByTimes } = useLDFlags();

  if (!signupScheduleByTimes) {
    return <Navigate to={routes.signupDirect.evaluation.schedule.split.first} replace />;
  }

  return <Navigate to={routes.signupDirect.evaluation.schedule.split.v2.first} replace />;
};
